export default "__VITE_ASSET__Bwn0qM$c__"